import React from 'react';
import { qualityLevels } from '../../utils/estimator';
import { tabBase, tabActive, tabIdle, sectionTitle } from './estimateUi';

export default function StepLevel({ isUA, level, onChange }) {
  return (
    <div className="relative z-[1] py-10 border-b border-border/60">
      <p className={`block ${sectionTitle}`}>{isUA ? 'Рівень оздоблення' : 'Finish level'}</p>
      <div className="relative z-[1] flex flex-wrap gap-3 items-start">
        {qualityLevels.map((ql) => (
          <button
            key={ql.id}
            type="button"
            onClick={() => onChange(ql.id)}
            className={`${tabBase} ${level === ql.id ? tabActive : tabIdle}`}
            data-testid={`cfg-level-${ql.id}`}
          >
            {isUA ? ql.labelUA : ql.labelEN}
          </button>
        ))}
      </div>
    </div>
  );
}
